/**
 * 指定されたREST APIエンドポイントから非同期にデータをプリフェッチし、
 * 結果をセッションストレージに保存します。
 * この関数は、プリフェッチが既に進行中でないことを確認した後に実行されます。
 * 各エンドポイントからデータをフェッチし、成功した場合はそのデータを
 * セッションストレージに保存します。プリフェッチ中にエラーが発生した場合は、
 * コンソールにエラーメッセージが表示されます。
 *
 * @async
 * @function prefetchData
 * @returns {Promise<void>} プリフェッチ処理が完了すると解決されるプロミス。
 */
// export default async function prefetchData() {

//   const endpoints = [
//     { key: 'book', url: `/wp-json/wp/v2/book?page=1&per_page=6` },
//     { key: 'interview', url: `/wp-json/wp/v2/interview?page=1&per_page=4` },
//     { key: 'news', url: `/wp-json/wp/v2/news?page=1&per_page=10` },
//   ];

//   for (const endpoint of endpoints) {
//     try {
//       const response = await fetch(endpoint.url);
//       if (!response.ok) {
//         throw new Error(`Failed to fetch ${endpoint.url}: ${response.statusText}`);
//       }
//       const data = await response.json();

//       // セッションストレージにデータを直接保存
//       sessionStorage.setItem(`prefetchedData_${endpoint.key}`, JSON.stringify(data));
//       console.log(`Data for ${endpoint.key} が保存されました`);
//     } catch (error) {
//       console.error(`Error prefetching data from ${endpoint.url}:`, error);
//     }
//   }
// }
export default function prefetchData() {

  const endpoints = [
    { key: 'book', url: `/wp-json/wp/v2/book?page=1&per_page=6` },
    { key: 'interview', url: `/wp-json/wp/v2/interview?page=1&per_page=4` },
    { key: 'news', url: `/wp-json/wp/v2/news?page=1&per_page=10` },
  ];

  Promise.all(
    endpoints.map(endpoint => fetch(endpoint.url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch ${endpoint.url}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        sessionStorage.setItem(`prefetchedData_${endpoint.key}`, JSON.stringify(data));
        //console.log(`Data for ${endpoint.key} が保存されました`);
      })
      .catch(error => {
        console.error('Error prefetching data:', error);
      })
    )
  );
}

/** ========================
 * 実行
 * ========================== */
prefetchData();
